export const CustomerDetailsTab = {
  CONTACTS: 'CONTACTS',
  MAIN: 'MAIN',
  PROCESSES: 'PROCESSES',
  RECURRING_RESERVATIONS: 'RECURRING_RESERVATIONS',
  TASKS: 'TASKS',
} as const;

export type CustomerDetailsTab = (typeof CustomerDetailsTab)[keyof typeof CustomerDetailsTab];
